import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { PaintSurface } from '@/scripts/optional/paint-surface'

export class PaintPopup extends UcoastEl {
    static htmlSelector = 'paint-popup'
    triggerButton: HTMLButtonElement
    closeButton: HTMLButtonElement
    content: HTMLElement
    constructor() {
        super()
        this.triggerButton = q.rs('.paint-popup-trigger', this)
        this.closeButton = q.rs('.paint-popup-close', this)
        this.content = q.rs('.paint-popup-content', this)

		// In development, keep the popup content statically open for quick testing
		// const isDev =
		// 	((import.meta as any)?.env?.DEV ?? false) ||
		// 	location.hostname === 'localhost' ||
		// 	location.hostname === '127.0.0.1'

		// if (isDev) {
        //     this.content.classList.add('active')
        //     return
        // }

        this.triggerButton.addEventListener('click', this.onOpenClick.bind(this))
        this.closeButton.addEventListener('click', this.onCloseClick.bind(this))
    }

	private async onOpenClick(_e: Event) {
		if (this.content.classList.contains('active')) return
		this.content.classList.add('active')
		this.resetSurface()
		await this.ensureSurfaceLayout()
	}

	private onCloseClick(_e: Event) {
		if (!this.content.classList.contains('active')) return
		const confirmed = window.confirm('Are you sure you want to leave?')
		if (!confirmed) return
		this.content.classList.add('closing')
		const onEnd = () => {
			this.content.removeEventListener('transitionend', onEnd)
			this.content.classList.remove('active')
			this.content.classList.remove('closing')
			this.resetSurface()
		}
		// Fallback in case transitionend doesn't fire
		this.content.addEventListener('transitionend', onEnd)
		window.setTimeout(onEnd, 300)
	}

	private resetSurface() {
		// Reset the embedded paint surface to a clean state after open/close
		const surface = this.querySelector('paint-surface')
		if (surface instanceof PaintSurface) {
			surface.reset()
			return
		}
		// If not yet upgraded, wait for definition and try again once
		customElements.whenDefined(PaintSurface.htmlSelector).then(() => {
			const el = this.querySelector('paint-surface')
			if (el instanceof PaintSurface) {
				el.reset()
			}
		}).catch(() => {})
	}

	private async ensureSurfaceLayout(): Promise<void> {
		const run = async (surf: PaintSurface) => {
			// Let styles settle a frame for accurate layout
			await new Promise<void>((r) => requestAnimationFrame(() => r()))
			await surf.reflow()
		}
		const surface = this.querySelector('paint-surface')
		if (surface instanceof PaintSurface) {
			await run(surface)
			return
		}
		await customElements.whenDefined(PaintSurface.htmlSelector).then(async () => {
			const el = this.querySelector('paint-surface')
			if (el instanceof PaintSurface) {
				await run(el)
			}
		}).catch(() => {})
	}
}
